
// SVG Icon: line-chart
export default { id: "terriajs-line-chart" };
export const id = "terriajs-line-chart";
export const name = "line-chart";
